import { render, staticRenderFns } from "./Incoming.vue?vue&type=template&id=588402a8&"
import script from "./Incoming.vue?vue&type=script&lang=js&"
export * from "./Incoming.vue?vue&type=script&lang=js&"
import style0 from "./Incoming.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports